import * as tslib_1 from "tslib";
import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { LayerApi } from '../api/layer-api';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { DocumentSources } from '../types';
import * as i0 from "@angular/core";
import * as i1 from "../api/layer-api";
import * as i2 from "@angular/platform-browser";
var DocumentService = /** @class */ (function () {
    function DocumentService(layerApi, sanitizer) {
        this.layerApi = layerApi;
        this.sanitizer = sanitizer;
        this.ecsAliases = {
            documentClass: 'Class',
            documentType: 'Type',
            title: 'Title',
            fileName: 'Name',
            mimeType: 'Mime Type',
            source: 'Source',
            size: 'File Size',
            url: 'Url',
            documentId: 'Document Id',
            creationDate: 'Created',
            lastModificationDate: 'Modified'
        };
        this.mimeTypeImages = ['image/apng', 'image/avif', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp', 'image/bmp'];
        //sources (notify)
        this.fullScreenImagesRequested = new Subject();
        this.fullScreenVideoRequested = new Subject();
        //streams (listen)
        this.fullScreenImagesRequestedObservable = this.fullScreenImagesRequested.asObservable();
        this.fullScreenVideoRequestedObservable = this.fullScreenVideoRequested.asObservable();
    }
    DocumentService.prototype.getDocuments = function (record, docSources, layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getLayerDocuments(record, layer),
                            this.getSourceDocuments(record, docSources)
                        ])];
                    case 1:
                        documents = _a.sent();
                        return [2 /*return*/, documents.flat()];
                }
            });
        });
    };
    DocumentService.prototype.getLayerDocSources = function (layerIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getLayers(layerIds, 'id docSources: layerDocSource { id type url fields template options }')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DocumentService.prototype.getTableDocSources = function (tableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getTable(tableId, 'id docSources { id type url fields template options }')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DocumentService.prototype.isImage = function (document) {
        return document ? document.source === DocumentSources.PHOTO || this.mimeTypeImages.includes(document.mimeType) : false;
    };
    DocumentService.prototype.isVideo = function (document) {
        return document ? document.source === DocumentSources.VIDEO : false;
    };
    DocumentService.prototype.requestFullScreenImages = function (documents) {
        this.fullScreenImagesRequested.next(documents);
    };
    DocumentService.prototype.requestFullScreenVideo = function (document) {
        this.fullScreenVideoRequested.next(document);
    };
    DocumentService.prototype.getSourceDocuments = function (record, docSources) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, documents, _loop_1, this_1, docSources_1, docSources_1_1, docSource, e_1_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        documents = [];
                        _loop_1 = function (docSource) {
                            var e_2, _a, options, fields, source_1, title, description, _b, query, documentsUrl, results, results_1, results_1_1, r, photoUrl, prefix, thumbnail, videoUrl, deviceId, documentsVideoUrl, result, _c, FeatureLayer, attachmentLayer, where, attachmentsByObjectId_1, attachments;
                            return tslib_1.__generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        options = JSON.parse(docSource.options);
                                        fields = JSON.parse(docSource.fields);
                                        if (!fields) return [3 /*break*/, 13];
                                        source_1 = docSource.type;
                                        title = this_1.getAttributeValue(record.attributes, fields.docTitleField || fields.docVideoField.replace(' ', '_'));
                                        description = fields.docDescField ? this_1.getAttributeValue(record.attributes, fields.docDescField) : null;
                                        _b = source_1;
                                        switch (_b) {
                                            case DocumentSources.ECS: return [3 /*break*/, 1];
                                            case DocumentSources.PHOTO: return [3 /*break*/, 3];
                                            case DocumentSources.VIDEO: return [3 /*break*/, 4];
                                            case DocumentSources.FEATURE: return [3 /*break*/, 7];
                                        }
                                        return [3 /*break*/, 12];
                                    case 1:
                                        query = this_1.getQueryClause(record, fields.docQueryFields, options.query, options.operator);
                                        documentsUrl = "ecs/documents?query=" + query + "&sourceName=" + options.source;
                                        return [4 /*yield*/, this_1.layerApi.Api.http2.get(documentsUrl)];
                                    case 2:
                                        results = _d.sent();
                                        try {
                                            for (results_1 = tslib_1.__values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                                                r = results_1_1.value;
                                                documents.push({
                                                    source: source_1,
                                                    title: r.titleSubject,
                                                    fileName: r.originalFileName,
                                                    mimeType: r.mimeType,
                                                    url: environment.apiBaseUrl + "/ecs/document/" + r.documentId + "?sourceName=" + options.source,
                                                    documentId: r.documentId,
                                                    documentClass: r.documentClass,
                                                    documentType: r.documentType,
                                                    size: r.size,
                                                    creationDate: r.creationDate,
                                                    lastModificationDate: r.lastModificationDate
                                                });
                                            }
                                        }
                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                        finally {
                                            try {
                                                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                        }
                                        //}
                                        return [3 /*break*/, 13];
                                    case 3:
                                        photoUrl = this_1.getAttributeValue(record.attributes, fields.docImageField);
                                        prefix = this_1.isBase64(photoUrl) ? 'data:image/png;base64,' : '';
                                        documents.push({ source: source_1, title: title, description: description, url: "" + prefix + photoUrl });
                                        return [3 /*break*/, 13];
                                    case 4:
                                        thumbnail = this_1.getAttributeValue(record.attributes, fields.docImageField);
                                        videoUrl = void 0;
                                        deviceId = void 0;
                                        if (thumbnail && thumbnail.indexOf('thumbs') > -1 && thumbnail.toUpperCase().indexOf('CAM') > -1) {
                                            deviceId = thumbnail.substring(thumbnail.toUpperCase().indexOf('CAM'), thumbnail.length);
                                        }
                                        if (!deviceId) return [3 /*break*/, 6];
                                        deviceId = deviceId.substring(deviceId.toUpperCase().indexOf('CAM'), deviceId.toUpperCase().indexOf('.'));
                                        documentsVideoUrl = "trafficCamera/getPropertiesById/" + deviceId;
                                        return [4 /*yield*/, this_1.layerApi.Api.http2.post(documentsVideoUrl)];
                                    case 5:
                                        result = _d.sent();
                                        videoUrl = result.httpsUrl;
                                        thumbnail = result.imageUrl;
                                        if (window.environment.indexOf('internal') === -1) {
                                            thumbnail = environment.apiBaseUrl + "/camera/" + result.imageUrl.substring(result.imageUrl.indexOf('CAM'));
                                        }
                                        _d.label = 6;
                                    case 6:
                                        documents.push({ source: source_1, title: title, description: description, url: videoUrl, thumbnail: thumbnail, displayText: this_1.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this_1.sanitizer.bypassSecurityTrustResourceUrl(videoUrl)) });
                                        return [3 /*break*/, 13];
                                    case 7:
                                        if (!(docSource.url && fields && fields.docQueryFields)) return [3 /*break*/, 11];
                                        return [4 /*yield*/, Promise.all([ESRI.FeatureLayer])];
                                    case 8:
                                        _c = tslib_1.__read.apply(void 0, [_d.sent(), 1]), FeatureLayer = _c[0];
                                        attachmentLayer = new FeatureLayer({ url: docSource.url });
                                        return [4 /*yield*/, attachmentLayer.load()];
                                    case 9:
                                        _d.sent();
                                        where = this_1.getQueryClause(record, fields.docQueryFields, options.query, options.operator);
                                        return [4 /*yield*/, attachmentLayer.queryAttachments({ where: where })];
                                    case 10:
                                        attachmentsByObjectId_1 = _d.sent();
                                        attachments = Object.keys(attachmentsByObjectId_1).flatMap(function (objectId) { return attachmentsByObjectId_1[objectId]; });
                                        attachments.forEach(function (a) {
                                            documents.push({
                                                source: source_1,
                                                title: a.name,
                                                fileName: a.name,
                                                mimeType: a.contentType,
                                                url: a.url,
                                                documentId: a.id,
                                                size: a.size,
                                                parentObjectId: a.parentObjectId,
                                                keywords: a.keywords,
                                                exifInfo: a.exifInfo
                                            });
                                        });
                                        attachmentLayer.destroy();
                                        _d.label = 11;
                                    case 11: return [3 /*break*/, 13];
                                    case 12: return [3 /*break*/, 13];
                                    case 13: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        docSources_1 = tslib_1.__values(docSources), docSources_1_1 = docSources_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!docSources_1_1.done) return [3 /*break*/, 5];
                        docSource = docSources_1_1.value;
                        return [5 /*yield**/, _loop_1(docSource)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        docSources_1_1 = docSources_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (docSources_1_1 && !docSources_1_1.done && (_a = docSources_1.return)) _a.call(docSources_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, documents];
                }
            });
        });
    };
    DocumentService.prototype.getLayerDocuments = function (record, layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents, objectId, attachments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        documents = [];
                        if (!(layer && layer.capabilities && layer.capabilities.data && layer.capabilities.data.supportsAttachment)) return [3 /*break*/, 2];
                        objectId = this.getAttributeValue(record.attributes, 'objectId');
                        return [4 /*yield*/, layer.queryAttachments({ objectIds: [Number(objectId)] })];
                    case 1:
                        attachments = _a.sent();
                        //const attachments = Object.keys(attachmentsByObjectId).flatMap((objectId) => attachmentsByObjectId[objectId]); s
                        attachments[objectId].forEach(function (a) {
                            documents.push({
                                source: DocumentSources.FEATURE,
                                title: a.name,
                                fileName: a.name,
                                mimeType: a.contentType,
                                url: a.url,
                                documentId: a.id,
                                size: a.size,
                                parentObjectId: a.parentObjectId,
                                keywords: a.keywords,
                                exifInfo: a.exifInfo
                            });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/, documents];
                }
            });
        });
    };
    DocumentService.prototype.getQueryClause = function (record, docQueryFields, query, operator) {
        var e_3, _a;
        var clauses = (query) ? [query] : [];
        try {
            for (var docQueryFields_1 = tslib_1.__values(docQueryFields), docQueryFields_1_1 = docQueryFields_1.next(); !docQueryFields_1_1.done; docQueryFields_1_1 = docQueryFields_1.next()) {
                var q = docQueryFields_1_1.value;
                var value = this.getAttributeValue(record.attributes, q.docQryField);
                var delm = (q.docQryFieldAliasType && q.docQryFieldAliasType === 'number') ? '' : "'";
                if (operator && operator.toLowerCase().trim() === 'like') {
                    value = encodeURI("%" + value + "%");
                }
                if (operator && operator.toLowerCase().trim() === 'in') {
                    clauses.push("ANY " + q.docQryFieldAlias + " " + operator + " (" + delm + value + delm + ")");
                }
                else {
                    clauses.push(q.docQryFieldAlias + " " + (operator ? operator : '=') + " " + delm + value + delm);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (docQueryFields_1_1 && !docQueryFields_1_1.done && (_a = docQueryFields_1.return)) _a.call(docQueryFields_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return (clauses.length > 1) ? clauses.join(' and ') : clauses[0];
    };
    DocumentService.prototype.getAttributeValue = function (attributes, columnName) {
        var attribute = attributes.find(function (a) { return a.columnName.toLowerCase() === columnName.toLowerCase(); });
        return attribute ? attribute.value : null;
    };
    DocumentService.prototype.isBase64 = function (s) {
        //Image may be base64 (example - RWIS weather station images)
        try {
            if (s) {
                atob(s);
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    };
    DocumentService.ngInjectableDef = i0.defineInjectable({ factory: function DocumentService_Factory() { return new DocumentService(i0.inject(i1.LayerApi), i0.inject(i2.DomSanitizer)); }, token: DocumentService, providedIn: "root" });
    return DocumentService;
}());
export { DocumentService };
